import { render, staticRenderFns } from "./TicketCreateStudentStaff.vue?vue&type=template&id=2a624613&"
import script from "./TicketCreateStudentStaff.vue?vue&type=script&lang=js&"
export * from "./TicketCreateStudentStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports